import { createFileRoute } from "@tanstack/react-router";

import { CoachWorkflowProgramPage } from "src/pages/CoachWorkflowProgramPage";

export const Route = createFileRoute("/_auth/_coach/workflows/$workflowId/")({
  component: RouteComponent,
  staticData: {
    getScrollRestoration: () => {
      return false;
    },
  },
});

function RouteComponent() {
  return <CoachWorkflowProgramPage />;
}
